import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';

export interface ExportacaoLancamentoPreviewRow {
  data: string;
  categoria: string;
  historico: string;
  tipo: string;
  valor: string;
  tags: string;
  conta: string;
}

export interface ModalExportarLancamentosData {
  quantidadeRegistros: number;
  colunas: string[];
  previewRows: ExportacaoLancamentoPreviewRow[];
}

@Component({
  selector: 'app-modal-exportar-lancamentos',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatTableModule],
  templateUrl: './modal-exportar-lancamentos.component.html',
  styleUrls: ['./modal-exportar-lancamentos.component.css'],
})
export class ModalExportarLancamentosComponent {
  public displayedColumns: string[] = ['data', 'categoria', 'historico', 'tipo', 'valor'];

  constructor(
    public dialogRef: MatDialogRef<ModalExportarLancamentosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalExportarLancamentosData
  ) {}

  public confirmar(): void {
    this.dialogRef.close(true);
  }
}
